import * as React from 'react'

import { Box, Icon, Spinner, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useFetchTimeSettingsCustomTimeRangeCategories } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import ArchivedItem from './ArchivedItem'

interface Props {
  companyId: number
}

const ArchivedCategories = ({ companyId }: Props) => {
  const { loading, archivedCategories } = useFetchTimeSettingsCustomTimeRangeCategories(companyId)
  const [open, setOpen] = React.useState(false)
  const [openInfo, toggleOpenInfo] = useToggle()

  if (archivedCategories.length === 0) return null

  return (
    <Box gap="s16">
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Box
          flexDirection="row"
          alignItems="center"
          gap="s8"
          cursor="pointer"
          onClick={() => setOpen(!open)}
        >
          <Icon.Tiny icon={open ? 'caret-up' : 'caret-down'} color="grey1000" />

          <Text.Normal size="200" weight="semibold" color="grey1000">
            {i18n.t('work_time_categories.actions.archived_categories')}
          </Text.Normal>

          <Tooltip.Alt
            attachment="bottom center"
            targetAttachment="top center"
            open={openInfo}
            toggle={toggleOpenInfo}
            label={i18n.t('work_time_categories.actions.archived_message')}
          >
            <Icon.Medium icon="info-circle-line" color="grey1000" />
          </Tooltip.Alt>
        </Box>
      </Box>

      {open && loading && (
        <Box alignItems="center" width="full" padding="s32">
          <Spinner />
        </Box>
      )}

      {open && !loading && (
        <Box
          width="full"
          paddingY="s16"
          paddingX="s24"
          gap="s8"
          component="ul"
          borderRadius={{ all: 'abs008' }}
          border={{
            all: {
              width: 's1',
              color: 'grey400',
              style: 'solid',
            },
          }}
        >
          {archivedCategories.map((category) => (
            <ArchivedItem category={category} key={category.id} />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default observer(ArchivedCategories)
